var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-section col-12 float-l border-top-edeeef pt_18 pb_20"
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "p",
            {
              staticClass:
                "left-footer-section float-l left color-888888 font-text-regular-benton heading-text-12 line-height-16 mb_0"
            },
            [_vm._v(" Signed in " + _vm._s(_vm.sessionCount) + " Devices ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "right-footer-section float-r right font-benton-medium heading-text-12 line-height-16 mb_0"
            },
            [
              _c(
                "a",
                {
                  staticClass: "color-f5911e",
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.deleteSession()
                    }
                  }
                },
                [_vm._v(" Delete all Session ")]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loading-container", staticStyle: { display: "none" } },
      [
        _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/static/images/loading.gif" } })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da50d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da50d10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = null
// module chunks = 